
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"m15 13.586-3.113-3.113a6 6 0 0 0-9.13-7.715 6 6 0 0 0 7.715 9.129L13.585 15A1.0002026 1.0002026 0 1 0 15 13.586M4.171 9.829a4 4 0 1 1 5.658 0 4.006 4.006 0 0 1-5.657 0"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  